/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import React, { useState, Dispatch, SetStateAction, useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import { ICustomerData, IPlanData } from 'src/environments/Checkout/interfaces';
import { apiCheckout } from 'src/environments/Checkout/api';

import CreditCardForm from './components/CreditCardForm';

import loadingGIF from '../../../../../../assets/gifs/loading.png';
import ConcludePurchase from './components/ConcludePurchase';

type Props = {
  customerData: ICustomerData;
  planData: IPlanData;
  setComponent: Dispatch<SetStateAction<number>>;
  platform: string;
};

export default function PurchasePayment({
  customerData,
  planData,
  setComponent,
  platform,
}: Props): JSX.Element {
  const [showCardForm, setShowCardForm] = useState(false);

  const { token } = useParams();

  useEffect(() => {
    const log = async () => {
      await apiCheckout.createLogCustomerData(
        'Use effect 2 PurchasePayment',
        JSON.stringify(customerData),
        token
      );
    };

    void log();

    if (!customerData?.customerCpf || customerData?.customerCpf === '') {
      setComponent(0);
      global.alert('Preencha seu cpf corretamente');
    }
  }, [customerData]);

  const {
    isLoading: loadingCardsIds,
    isError,
    data: cardsIds,
  } = useQuery(['getCardsIds', token], async () => apiCheckout.getCardsIds(token), {
    onError: () => {
      void Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Por favor, tente novamente mais tarde, ou contate a central.',
        iconColor: 'black',
        confirmButtonColor: 'black',
      });
    },
    onSuccess: () => {},
    refetchOnWindowFocus: false,
  });

  if (loadingCardsIds || isError) {
    return <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />;
  }

  return (
    <>
      {showCardForm || cardsIds.length === 0 ? (
        <CreditCardForm
          customerData={customerData}
          setShowCardForm={setShowCardForm}
          hasCards={cardsIds.length > 0}
        />
      ) : (
        <ConcludePurchase
          customerData={customerData}
          setShowCardForm={setShowCardForm}
          cardsIds={cardsIds}
          planData={planData}
          setComponent={setComponent}
          platform={platform}
        />
      )}
    </>
  );
}
